import React, {useEffect, useState} from 'react'

import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {useRouter} from 'next/router'
import {SearchResponse} from '@algolia/client-search'

import {VariantList} from '@festi/common/api/rest'
import {fluidRange} from '@festi/common/utils/styles'
import {useUserPrices} from '@festi/common/utils/rest'
import {sendEcommerceItemListEvent} from '@festi/common/utils/tagmanager'

import HorizontalProductCard from 'src/components/cards/redesign/HorizontalProductCard'

const RelatedContainer = styled.div`
  padding-block: 24px;

  ${media.md`
    padding-block: 60px;
    border-top: 1px solid ${palette('ui10Solid')};
  `}
`

const Title = styled.h5`
  font-size: 20px;
  font-weight: 500;
  ${fluidRange('padding-bottom', '20px', '40px')};
`

const ProductListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  ${media.md`
    flex-direction: row;
    gap: 12px;
  `}
`

interface Props {
  variants: SearchResponse<VariantList>
}

const list = 'AR Related Products'

export default function ProductRelated({variants}: Props) {
  const {asPath} = useRouter()
  const [viewed, setViewed] = useState('')

  const {data: userPrices} = useUserPrices(
    variants?.hits?.map((variant) => variant.sku),
  )

  // TODO: Change back to 5 when we do the comparison table
  const firstFiveProducts = variants?.hits?.slice(0, 4)

  const hasProducts = !!firstFiveProducts?.length
  const triggerAnalytics = hasProducts && (viewed === '' || viewed !== asPath)

  useEffect(() => {
    if (triggerAnalytics) {
      setViewed(asPath)
      sendEcommerceItemListEvent(firstFiveProducts, list)
    }
  }, [asPath, firstFiveProducts, triggerAnalytics])

  if (!variants?.hits?.length) return null

  return (
    <RelatedContainer>
      <Title>Sambærilegar vörur</Title>
      <ProductListWrapper>
        {/* Note: Using the horizontal product card here until we do the comparison table */}
        {firstFiveProducts?.map((variant: VariantList, index) => (
          <HorizontalProductCard
            key={variant.sku}
            image={{
              url: variant.firstImage?.image?.webpXs,
              jpg: variant.firstImage?.image?.jpgXs,
              alt: variant.firstImage?.alt,
            }}
            origin={list}
            variant={variant}
            position={index + 1}
            userPrice={userPrices[variant.sku]}
            addToCart
          />
        ))}
      </ProductListWrapper>
    </RelatedContainer>
  )
}
